module.exports = __webpack_public_path__ + "static/media/Promotion_Card_MY.3f15543e.jpg";